const firebaseConfig = {
  apiKey: "AIzaSyBaS8vi5PEOwO97TV5XPP1wbuQrKD7Tp8w",
  authDomain: "nec-mobile-ticketing.firebaseapp.com",
  databaseURL: "https://nec-mobile-ticketing.firebaseio.com",
  projectId: "nec-mobile-ticketing",
  storageBucket: "nec-mobile-ticketing.appspot.com",
};

export default firebaseConfig;
